<template>
  <div>
    <h2 class="bordered-box-header">Ścieżka nauki kursanta</h2>
    <b-container fluid class="bordered-box">
      <b-row class="justify-content-center" v-if="!loaded && loading">
        <b-spinner big label="Loading..."></b-spinner>
      </b-row>
      <b-row v-else-if="loaded">
        <b-col xl="6" cols="12">
          <h3 class="big-margin">Kursy zrealizowane / w trakcie realizacji</h3>
          <span v-if="!lockedItems.length" class="text-danger">Brak kursów</span>
          <b-row
            v-for="item in lockedItems"
            :key="item.id"
            class="item locked-item"
            :class="{'selected-item': selectedItem == item}"
            @click="selectedItem = item"
            no-gutters
          >
            <span>{{item.name}}</span>
          </b-row>
        </b-col>
        <b-col xl="6" cols="12">
          <h3 class="big-margin">Kursy zaplanowane do realizacji</h3>
          <button class="btn btn-primary add-item" @click="showAddNewCourseModal">Utwórz nowy kurs</button>
          <button class="btn btn-secondary add-item" @click="showAssignTemplateModal">Przypisz kurs</button>

          <draggable
            v-model="activeItems"
            @start="drag=true"
            @end="drag=false"
            @change="onOrderChanged"
          >
            <b-row
              v-for="item in activeItems"
              :key="item.id"
              class="item active-item"
              :class="{'selected-item': selectedItem == item}"
              @click="selectedItem = item"
              no-gutters
            >
              <span>{{item.name}}</span>
            </b-row>
          </draggable>
        </b-col>
      </b-row>
    </b-container>
    <courseDetails
      v-if="selectedItem"
      :id="selectedItem.id"
      :key="selectedItem.id"
      @changed="onSelectedItemChanged"
      @deleted="onSelectedItemDeleted"
    />
    <addNewCourseModal ref="addNewCourseModal" @save="onAddNew" />
    <assignCourseTemplateModal ref="assignTemplateModal" @save="onAssignTemplate" />
  </div>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";

import draggable from "vuedraggable";
import courseDetails from "./DetailsCourseItem";
import addNewCourseModal from "./DetailsCourseAddEditCourseModal";
import assignCourseTemplateModal from "./DetailsCourseAssignCourseTemplateModal";

export default {
  data() {
    return {
      loaded: false,
      loading: false,
      activeItems: null,
      lockedItems: null,
      selectedItem: null
    };
  },
  components: {
    draggable,
    courseDetails,
    addNewCourseModal,
    assignCourseTemplateModal
  },
  props: ["id"],
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      if (this.id) {
        this.loading = true;

        axios
          .get("/students/courses", {
            params: {
              id: this.id
            }
          })
          .then(response => {
            this.loaded = true;
            let items = response.data;

            this.activeItems = items.filter(s => !s.locked);
            this.lockedItems = items.filter(s => s.locked);
          })
          .catch(error => eventBus.$emit("unhandled-error", error))
          .then(() => {
            this.loading = false;
          });
      }
    },
    onOrderChanged() {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });

      var r = {
        userId: this.id,
        items: this.activeItems.map(e => e.id)
      };

      axios
        .post("/students/courses/order", r)
        .then(() => {
          eventBus.$emit("notify-success", "Zapisano poprawnie.");
        })
        .catch(error => {
          eventBus.$emit("unhandled-error", error);
          this.refresh();
        })
        .then(() => {
          loader.hide();
        });
    },
    showAddNewCourseModal() {
      this.$refs.addNewCourseModal.show();
    },
    showAssignTemplateModal() {
      this.$refs.assignTemplateModal.show();
    },
    onAddNew(r) {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });

      r.userId = this.id;

      axios
        .post("/courses", r)
        .then(response => {
          eventBus.$emit("notify-success", "Zapisano poprawnie.");
          var result = response.data;
          this.activeItems.push(result);
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          loader.hide();
        });
    },
    onAssignTemplate(id) {
      let loader = this.$loading.show({
        container: this.$refs.mainContainer
      });

      var postParams = {
        userId: this.id,
        templateId: id
      };

      axios
        .post("/courses/template", postParams)
        .then(response => {
          eventBus.$emit("notify-success", "Zapisano poprawnie.");
          var result = response.data;
          this.activeItems.push(result);
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          loader.hide();
        });
    },
    onSelectedItemChanged(data) {
      this.selectedItem.name = data.name;
    },
    onSelectedItemDeleted() {
      this.activeItems = this.activeItems.filter(
        s => s.id != this.selectedItem.id
      );
      this.selectedItem = null;
    },
    goto(url) {
      this.$router.push(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.item {
  border: 1px solid rgba(0, 0, 0, 0.125);
  background: rgba(0, 0, 0, 0.03);
  border-radius: 1px;
  padding: 5px;
  margin-bottom: -1px;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.06);
  }
}
.active-item {
  cursor: move;
}
.selected-item {
  background: rgba(0, 255, 0, 0.125);

  &:hover {
    background: rgba(0, 255, 0, 0.25);
  }
}
.add-item {
  margin: 0px 10px 10px 0px;
}
.big-margin {
  margin-top: 10px;
}
h2.bordered-box-header {
  margin-top: 20px;
  padding: 10px;
  margin-bottom: 0px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.bordered-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px;
}
</style>